module.exports = __webpack_public_path__ + "img/kaishi.e1cb3f97.png";